import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-ho-bg">
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 text-center">
        <Logo />
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="mt-8 w-full rounded-[32px] border border-black/5 bg-white p-8">
          <div className="mx-auto grid place-items-center w-16 h-16 rounded-full bg-black/5">
            <RotateCcw className="h-8 w-8 text-ho-muted" />
          </div>
          <h1 className="font-display mt-5 text-2xl font-bold">Checkout cancelled</h1>
          <p className="mt-2 text-ho-muted">No charge was made. You can upgrade anytime.</p>
          <button onClick={() => navigate("/pricing")} data-testid="payment-cancel-retry"
            className="tap-scale mt-6 w-full rounded-full bg-ho-primary py-3.5 font-semibold text-white">
            Back to pricing
          </button>
          <button onClick={() => navigate("/app")} data-testid="payment-cancel-dashboard"
            className="tap-scale mt-3 w-full rounded-full bg-black/5 py-3.5 font-semibold">
            Go to dashboard
          </button>
        </motion.div>
      </div>
    </div>
  );
}
